<template>
  <button class="meeting-note-button h-full flex items-center gap-1.5 hover:bg-blue-900 transition-all"
          :class="{'pointer-events-none': isParticipantRole()}"
    @click="onClick">
    <div class="w-12 h-12 flex justify-center items-center relative">
      <div class="w-12 h-12 flex justify-center items-center absolute"
           :class="{'animate-glow': isPending}"
      ></div>
      <img class="ai_chat_svg" src="@/assets/images/meeting-note/ai_chat.svg" alt="ai_chat.svg" />
      <div v-if="isOngoingMeetingNote" class="record-background absolute top-0 left-0 w-full h-full"></div>
      <div v-if="isOngoingMeetingNote" class="record-time absolute">{{ meetingNoteDurationForm }}</div>
    </div>
  </button>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import moment from "moment/moment";
import GrmIcon from "@/components/Common/icon/GrmIcon.vue";

export default {
  name: "BtnMeetingNote",
  data() {
    return {
      spendingTime: 0,
      timerIntervalId: null,
      timerIntervalTerm: 100,
    }
  },
  computed: {
    ...mapGetters('user', ['hasEmceeRole', 'isParticipantRole']),
    ...mapGetters('meetingNote', [
        'ongoingMeetingNote',
        'isOngoingMeetingNote',
        'summaryState',
        'writingTime',
    ]),
    isPending(){
      return this.summaryState === 'pending'
    },
    meetingNoteDurationForm(){
      let mo = moment.utc(0).millisecond(this.writingTime);
      let minute = mo.hours() * 60 + mo.minutes()
      if(Number(minute) < 10){
        minute = "0"+minute
      }
      return minute+mo.format(':ss');
    },
  },
  methods: {
    ...mapActions('meetingNote', [
        'startMeetingNote',
        'stopMeetingNote',
    ]),
    onClick(){
      if(this.isOngoingMeetingNote){
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.quit'),
          ok:() => {
            this.stopMeetingNote(this.ongoingMeetingNote);
          },
        })
      }else{
        return this.$alert({
          text: this.$t('extendMenu.meetingNote.start'),
          ok:() => {
            this.startMeetingNote()
          },
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai_chat_svg{
  width: 26px;
  height: 26px;
}
.record-time{
  font-size: 14px;
}
.record-background{
  background-color: #59f;
  opacity: 0.8;
}

.animate-glow{
  position: absolute;
  &::before, &::after {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    border-radius:50%;
    opacity:0.5;
    filter: blur(8px);
  }
  &::after{
    background-color:#00ffff;
    z-index: 1;
    animation : backglow2 2s ease infinite;
  }
  &::before{
    background-color:#ff0072;
    z-index: 2;
    animation : backglow1 3s ease infinite;
  }
}

@keyframes backglow1
{
  0% {
    transform: translate(10%, 10%) scale(1);
    opacity:0.5;
  }
  25% {
    transform: translate(-10%, 10%) scale(0.8);
    opacity:0.5;
  }
  50% {
    transform: translate(-10%, -10%) scale(1.2);
    opacity:0.8;
  }
  75% {
    transform: translate(10%, -10%) scale(1.1);
    opacity:0.2;
  }
  100% {
    transform: translate(10%, 10%) scale(1);
    opacity:0.5;
  }
}

@keyframes backglow2
{
  0% {
    transform: translate(-10%, -10%) scale(1);
    opacity:0.5;
  }
  25% {
    transform: translate(10%, -10%) scale(0.8);
    opacity:0.5;
  }
  50% {
    transform: translate(10%, 10%) scale(1.2);
    opacity:0.8;
  }
  75% {
    transform: translate(-10%, 10%) scale(1.1);
    opacity:0.2;
  }
  100% {
    transform: translate(-10%, -10%) scale(1);
    opacity:0.5;
  }
}
</style>